import React from 'react';
import { Radio, useTheme } from '@material-ui/core';

// Checkbox input
export const Checkbox = ({
    field: { name, value, onChange, onBlur },
    form: { errors, touched },
    id,
    label,
    className,
}) => {
    const theme = useTheme();
    return (
        <div>
            <input
                name={name}
                id={id}
                type="checkbox"
                value={value}
                checked={value}
                onChange={onChange}
                onBlur={onBlur}
                className={className}
            />
            <label htmlFor={id}>{label}</label>
            {touched[name] && (
                <div style={{ color: theme.palette.secondary.main, fontSize: '12px' }}>{errors[name]}</div>
            )}
        </div>
    );
};

// Checkbox group
export const CheckboxGroup = (props) => {
    const { value, onChange, onBlur, error, touched, label, className, children } = props;
    const theme = useTheme();

    const handleChange = (event) => {
        const target = event.currentTarget;
        let valueArray = [...props.value] || [];
        if (target.checked) {
            valueArray.push(target.id);
        } else {
            valueArray.splice(valueArray.indexOf(target.id), 1);
        }
        if (onChange) onChange(props.id, valueArray);
    };

    const handleBlur = () => {
        // take care of touched
        if (onBlur) onBlur(this.props.id, true);
    };

    return (
        <>
            <div className={className}>
                <fieldset>
                    <legend>{label}</legend>
                    {React.Children.map(children, (child) => {
                        return React.cloneElement(child, {
                            field: {
                                value: value.includes(child.props.id),
                                onChange: handleChange,
                                onBlur: handleBlur,
                            },
                        });
                    })}
                </fieldset>
            </div>
            {(error || touched) && <div style={{ color: theme.palette.secondary.main, fontSize: '12px' }}>{error}</div>}
        </>
    );
};

// Radio input
export const RadioButton = ({ field: { name, value, onChange, onBlur }, id, label, className, ...props }) => {
    return (
        <div>
            <Radio
                name={name}
                id={id}
                value={id} // could be something else for output?
                className={className}
                disableRipple
                color="primary"
                checked={id === value}
                onChange={onChange}
                onBlur={onBlur}
                {...props}
            />
            <label htmlFor={id}>{label}</label>
        </div>
    );
};

// Radio group
export const RadioButtonGroup = ({ error, touched, label, className, children, style = {} }) => {
    const theme = useTheme();
    return (
        <>
            <div className={className} style={style}>
                <legend>{label}</legend>
                {children}
            </div>
            {error && touched && <div style={{ color: theme.palette.secondary.main, fontSize: '12px' }}>{error}</div>}
        </>
    );
};
